import { notEmpty } from "../common";

export function normalizeWeights<T extends { weight?: number | undefined }>(
  weights: T[],
): [number, T][] {
  let currentWeight = 0;
  const totalWeight = weights.reduce((a, { weight }) => {
    return a + (weight ?? 1);
  }, 0);

  return weights
    .map<[number, T] | null>((b) => {
      if (b.weight == 0) return null;
      currentWeight += ((b.weight ?? 1) / totalWeight) * 100;
      return [currentWeight, b];
    })
    .filter(notEmpty);
}

export function pickWeightedRandom<T>(
  weightedItems: [number, T][],
  hashVal?: number,
) {
  hashVal = hashVal ?? Math.random() * 100;
  for (const [weight, item] of weightedItems) {
    if (hashVal <= weight) return item;
  }
  return weightedItems[0][1];
}
